import { IValidationRule } from "@/types"

const depreciationMatrixRules: { [s: string]: IValidationRule } = {
    depreciationRate: {
        required: true,
        type: "decimal",
        gt: 0
    },
}

export default depreciationMatrixRules
